import { Component } from '@angular/core';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { MatDialogRef } from '@angular/material/dialog';
import { SalesAdminService } from 'src/app/assabil-sales/services/sales-admin-service';
import { TargetType } from 'src/app/assabil-sales/models/entities/target-type';


@Component({
  selector: 'target-type-lov',
  templateUrl: './target-type-lov.component.html',
  styleUrls: ['./target-type-lov.component.scss']
})


export class TargetTypeLovComponent extends GenericLovComponent   {

   code         : string; 
   name         : string; 

   targetTypes: TargetType[] = [];

    columns = [
        {  prop: 'targetTypeCode',  name: 'Code'},
        {  prop: 'name',            name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<TargetTypeLovComponent>,
    protected salesAdminService  : SalesAdminService) {
    super();
    this.entityName = "targetType";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    this.salesAdminService.targetTypesGet(this.code, this.name).then(result => {
        this.targetTypes = result;
    })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeModal(row : TargetType){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------

}
